const buildFilterArray = function(searchString,ignoredParamNames){
    const filters = []

    if(!searchString) return
    
    searchString.split('&').forEach(param =>{
        const paramName = param.split('=')[0].replace('[]','')

        if(!ignoredParamNames.includes(paramName)) {
            filters.push({
                name: paramName,
                facets: []
            })
        }

        ignoredParamNames.push(paramName)
    })

    searchString.split('&').forEach(param =>{
        const paramName = param.split('=')[0].replace('[]','')

        filters.forEach(filter => {
            if(filter.name === paramName) filter.facets.push({
                name: param.split('=')[1],
                selected: true
            })
        })
    })

    return filters
}

const getSortOption = function(searchString){
    if(!searchString || !searchString.includes('sortBy')) return
    
    return searchString.split('&').find(param => {
        const paramName = param.split('=')[0].replace('[]','')
        return paramName === 'sortBy'
    }).split('=')[1]
}

const getTake = function(searchString){
    if(!searchString || !searchString.includes('take')) return
    
    return searchString.split('&').find(param => {
        const paramName = param.split('=')[0].replace('[]','')
        return paramName === 'take'
    }).split('=')[1]
}

const getTextSearch = function(searchString){
    if(!searchString || !searchString.includes('q')) return
    
    return searchString.split('&').find(param => {
        const paramName = param.split('=')[0].replace('[]','')
        return paramName === 'q'
    }).split('=')[1]
}

export default function(context){

    const searchString = decodeURI(location.search).slice(1)

    if(!searchString) {
        context.dispatch('performSearch')
        return
    }

    const ignoredParamNames = ['pageSize','sortBy','skip','take','q']
    const filters = buildFilterArray(searchString,ignoredParamNames)
    const sortOption = getSortOption(searchString)
    const take = getTake(searchString)
    const textSearch = getTextSearch(searchString)

    if(sortOption) context.commit('set_new_sorting',{value: sortOption})
    if(take) context.commit('set_take',take ? take : context.state.default_take)
    if(textSearch) context.commit('set_search_string',textSearch)
    context.commit('set_filters',filters)

    context.dispatch('performSearch')
    context.commit('reset_take_to_default')
}